import { Dto } from '@core/data/dto/dto';
import { DtoExport, DtoForceConstructor, DtoImport } from '@core/utils/dto';
import { Entity } from '@core/data/dto/entity';
import { copyObjectProperties } from '@core/utils/object';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { EmployeeIssueType } from './employee-issue-type';
import { EmployeeIssueSchema } from './employee-issue.schema';

@DtoForceConstructor
export class EmployeeIssue implements Entity {
    public code: string;
    public reason: string;
    public reasonDescription: string;
    public type: EmployeeIssueType;


    constructor(value?: any) {
        if (value) {
            copyObjectProperties.call(this, value);
        }
    }

    @DtoImport(EmployeeIssueSchema)
    static import(dto: Dto): any {
        return new EmployeeIssue(dto);
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: EmployeeIssueSchema,
        },
    ])
    export(type?: DtoType): any {}
}
